import { canPublishJourney, canUpdateJourney } from '@/stores/helpers/journeys-permissions.helper';

// Callers pass the app scope the control acts on, which is the analysis app for
// plans and every app in view for account rows. An empty scope means the handshake
// has not resolved yet and denies.
function grantedOnEveryApp (appIds: readonly string[], hasGrant: (appId: string) => unknown): boolean {
    return appIds.length > 0 && appIds.every((appId) => Boolean(hasGrant(appId)));
}

// Adoption plans are journey-backed (AdoptionPlan.journeyVersionId), so they reuse
// the journey feature area rather than a Predict entity of their own. Deliberately
// status-agnostic: the PRD grants this role editing on running plans as well as
// drafts, so the active-source grant is not required here.
export function canEditAdoptionPlans (appIds: readonly string[]): boolean {
    return grantedOnEveryApp(appIds, (appId) =>
        canUpdateJourney({ appId, source: undefined, target: undefined, journey: undefined }));
}

export function canPublishAdoptionPlans (appIds: readonly string[]): boolean {
    return grantedOnEveryApp(appIds, (appId) =>
        canPublishJourney({ appId, source: undefined, target: undefined }));
}

// The journey feature area has no `view` action, so the read-only floor is "the
// user holds some role on the Predict app". Ids are compared as strings because
// the auth store exposes numeric app ids while Predict resolves them as strings.
export function canViewAdoption (appId: string | null, accessibleAppIds: readonly number[]): boolean {
    if (!appId) {
        return false;
    }

    return accessibleAppIds.some((accessibleAppId) => String(accessibleAppId) === String(appId));
}
